import "../styles/LoadingSpinner.css";

const LoadingSpinner = ({ text = "Loading...", fullscreen = false, className = "" }) => {
  return (
    <div
      className={`pixel-loader ${fullscreen ? "pixel-loader--fullscreen" : ""} ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className="pixel-loader__spinner" aria-hidden="true" />
      {text && <span className="pixel-loader__text">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;
